"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidConfiguration = exports.isValidHistoricalComparisonInput = exports.MAXIMUM_COMPARISON_VALUE = exports.MINIMUM_COMPARISON_VALUE = exports.isValidRelativeDateRangeInput = exports.MAXIMUM_RELATIVE_UNITS = exports.MINIMUM_RELATIVE_UNITS = exports.isValidConstantComparison = exports.isValueWithinRange = void 0;
var models_1 = require("./models");
var window_1 = require("./features/window");
var isValueWithinRange = function (value, max, min) {
    return value !== null && value >= min && value <= max;
};
exports.isValueWithinRange = isValueWithinRange;
var isValidConstantComparison = function (value) {
    return (0, exports.isValueWithinRange)(value, Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER);
};
exports.isValidConstantComparison = isValidConstantComparison;
exports.MINIMUM_RELATIVE_UNITS = 1;
exports.MAXIMUM_RELATIVE_UNITS = 10000;
function isValidRelativeDateRangeInput(value) {
    return (0, exports.isValueWithinRange)(value, exports.MAXIMUM_RELATIVE_UNITS, exports.MINIMUM_RELATIVE_UNITS);
}
exports.isValidRelativeDateRangeInput = isValidRelativeDateRangeInput;
exports.MINIMUM_COMPARISON_VALUE = 1;
exports.MAXIMUM_COMPARISON_VALUE = 10000;
function isValidHistoricalComparisonInput(value) {
    return (0, exports.isValueWithinRange)(value, exports.MAXIMUM_COMPARISON_VALUE, exports.MINIMUM_COMPARISON_VALUE);
}
exports.isValidHistoricalComparisonInput = isValidHistoricalComparisonInput;
function isValidConfiguration(comparison, window, hasDateDimension) {
    var _a;
    if (comparison === null) {
        return false;
    }
    var isConstantComparison = (0, models_1.isStaticComparison)(comparison);
    var isHistoricalComparison = (0, models_1.isHistoricalComparisonSpec)(comparison);
    var isMarkBasedComparison = (0, models_1.isMarkBasedComparison)(comparison);
    if (isConstantComparison && !(0, exports.isValidConstantComparison)(comparison.value)) {
        return false;
    }
    if (isHistoricalComparison || isMarkBasedComparison) {
        var units = (_a = (isHistoricalComparison ? comparison.numberOfPeriods : comparison.numberOfMarks)) !== null && _a !== void 0 ? _a : null;
        if (!isValidHistoricalComparisonInput(units)) {
            return false;
        }
    }
    if (hasDateDimension && window === null) {
        return false;
    }
    if (window !== null && (0, window_1.isLatestDataWindow)(window) && !isValidRelativeDateRangeInput(window.duration.numberOfUnits)) {
        return false;
    }
    return true;
}
exports.isValidConfiguration = isValidConfiguration;
//# sourceMappingURL=validation.js.map